import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../../data/api/api';
import { ContainerBanner } from './Style';

export default function BannerSecundario() {
  const [bannerData, setBannerData] = useState(() => {
    // Tenta obter dados do localStorage no carregamento inicial
    const savedData = localStorage.getItem('bannerDataSecundario');
    return savedData ? JSON.parse(savedData) : null;
  });
  const [isLoading, setIsLoading] = useState(!bannerData); // Define loading com base na presença de dados

  useEffect(() => {
    const fetchBannerData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/banner-home-conteudo`);
        if (!response.ok) {
          throw new Error('Erro ao buscar os dados do banner');
        }
        const data = await response.json();
        if (data.length > 0) {
          setBannerData(data[0]); // Captura o primeiro item do array
          localStorage.setItem('bannerDataSecundario', JSON.stringify(data[0])); // Armazena no localStorage
        } else {
          console.error('Nenhum dado de banner encontrado');
        }
      } catch (error) {
        console.error('Erro ao buscar dados do banner:', error);
      } finally {
        setIsLoading(false);
      }
    };

    // Verifica se já existem dados no localStorage; se não, busca os dados
    if (!bannerData) {
      fetchBannerData();
    } else {
      setIsLoading(false); // Se os dados já estão disponíveis, não está mais carregando
    }
  }, [bannerData]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!bannerData || !bannerData.imagem) {
    return <div>Erro ao carregar o banner.</div>;
  }

  const { imagem } = bannerData;

  return (
    <ContainerBanner>
      <img src={`${API_BASE_URL}/storage/${imagem}`} alt="Banner Home Conteúdo" />
    </ContainerBanner>
  );
}
